import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationGuardService } from '../../shared/libs/auth/authorization-guard.service';
import { CompanyRole } from '../../models/shared/enums/company-role.enum';
import { SidenavTypeEnum } from '../../shared/models/sidebar-group.models';
import { CompanyComponent } from './component/company.component';
import { CompanyOrderListComponent } from './component/order-list/company-order-list.component';
import { StyleInfoComponent } from './component/style-info/style-info.component';
import { StyleComponent } from './component/style/style.component';
import { PhotographersComponent } from './component/photographers/photographers.component';
import { PhotographerEditComponent } from './component/photographer-edit/photographer-edit.component';
import { PhotographerOrdersComponent } from './component/photographer-orders/photographer-orders.component';
import { TemplatesComponent } from './component/templates/templates.component';
import { TemplateFormComponent } from './component/templates/template-form/template-form.component';
import { UnifiedOrderViewComponent } from './component/unified-order/unified-order-view.component';
import { UnifiedOrderDetailInfoComponent } from './component/unified-order/unified-order-detail-info/unified-order-detail-info.component';
import { UnifiedOrderDetailShotsComponent } from './component/unified-order/unified-order-detail-shots/unified-order-detail-shots.component';

const routes: Routes = [
	{
		path: '',
		component: CompanyComponent,
		data: { sidenavType: SidenavTypeEnum.company },
		children: [
			{
				path: '',
				redirectTo: 'order-list',
				pathMatch: 'full'
			},
			// {
			// 	path: 'dashboard',
			// 	component: CompanyDashboardComponent,
			// 	data: { title: 'Dashboard | Company | BasicStudios', roles: [CompanyRole.DASHBOARD_READ] },
			// 	canActivate: [AuthorizationGuardService]
			// },
			{
				path: 'order-info',
				redirectTo: 'order-list',
				pathMatch: 'full'
			},
			{
				path: 'order-info/order-detail-info/:orderId',
				redirectTo: 'order-view/:orderId/order-detail-info',
				pathMatch: 'full'
			},
			{
				path: 'order-info/order-detail-shots/:orderId',
				redirectTo: 'order-view/:orderId/order-detail-shots',
				pathMatch: 'full'
			},
			{
				path: 'order-list',
				component: CompanyOrderListComponent,
				data: { title: 'Order list | Company | BasicStudios', roles: [CompanyRole.ORDERLIST_READ] },
				canActivate: [AuthorizationGuardService]
			},

			{
				path: 'order-view',
				redirectTo: 'order-view/new',
				pathMatch: 'full'
			},
			{
				path: 'order-view/:orderId',
				component: UnifiedOrderViewComponent,
				data: { title: 'Order | Company | BasicStudios', roles: [CompanyRole.ORDERLIST_READ, CompanyRole.ORDERLIST_EDIT] },
				canActivate: [AuthorizationGuardService],
				children: [
					{
						path: '',
						redirectTo: 'order-detail-info',
						pathMatch: 'full'
					},
					{
						path: 'order-detail-info',
						component: UnifiedOrderDetailInfoComponent
					},
					{
						path: 'order-detail-shots',
						component: UnifiedOrderDetailShotsComponent
					}
				]
			},

			//OLD FORM
			// {
			// 	path: 'new-order',
			// 	component: OrderFormComponent,
			// 	data: { title: 'New Order | Company | BasicStudios', roles: [CompanyRole.ORDERLIST_EDIT] },
			// 	canActivate: [AuthorizationGuardService]
			// },
			//NEW FORM → redirect to unified view
			{
				path: 'new-order',
				redirectTo: 'order-view/new',
				pathMatch: 'full'
			},
			{
				path: 'new-order/order-detail-info',
				redirectTo: 'order-view/new/order-detail-info',
				pathMatch: 'full'
			},
			{
				path: 'new-order/order-detail-shots',
				redirectTo: 'order-view/new/order-detail-shots',
				pathMatch: 'full'
			},


			{
				path: 'style-info/:modelId',
				component: StyleInfoComponent,
				data: { title: 'Styles | Company | BasicStudios', roles: [CompanyRole.STYLES_READ] },
				canActivate: [AuthorizationGuardService]
			},
			{
				path: 'styles',
				component: StyleComponent,
				data: { title: 'Styles | Company | BasicStudios', roles: [CompanyRole.STYLES_READ] },
				canActivate: [AuthorizationGuardService]
			},
			{
				path: 'photographers',
				component: PhotographersComponent,
				data: { title: 'Photographers | Company | BasicStudios', roles: [CompanyRole.PHOTOGRAPHERS_READ] },
				canActivate: [AuthorizationGuardService]
			},
			{
				path: 'edit-photographer/:photographerId',
				component: PhotographerEditComponent,
				data: { title: 'Edit Photographers | Company | BasicStudios', roles: [CompanyRole.PHOTOGRAPHERS_EDIT] },
				canActivate: [AuthorizationGuardService]
			},
			{
				path: 'photographer-orders/:photographerId',
				component: PhotographerOrdersComponent,
				data: { title: 'Photographer Orders | Company | BasicStudios', roles: [CompanyRole.PHOTOGRAPHERS_READ] }
				// canActivate:[AuthorizationGuardService]
			},
			{
				path: 'templates',
				component: TemplatesComponent,
				data: { title: 'Templates | Company | BasicStudios', roles: [CompanyRole.TEMPLATES_READ] },
				canActivate: [AuthorizationGuardService]
			},
			{
				path: 'new-template',
				component: TemplateFormComponent,
				data: { title: 'New Template | Company | BasicStudios', roles: [CompanyRole.TEMPLATES_EDIT] },
				canActivate: [AuthorizationGuardService]
			},
			// {
			// 	path: 'management',
			// 	component: ManagementComponent,
			// 	data: { title: 'Management | Photographer | BasicStudios', roles: [CompanyRole.MANAGEMENT_READ] },
			// 	canActivate: [AuthorizationGuardService]
			// },
			// {
			// 	path: 'account',
			// 	component: AccountComponent,
			// 	data: { title: 'Account | Company | BasicStudios', roles: [CompanyRole.ACCOUNT_READ] },
			// 	canActivate: [AuthorizationGuardService]
			// },
			// {
			// 	path: 'settings',
			// 	component: SettingsComponent,
			// 	data: { title: 'Account | Company | BasicStudios' },
			// 	canActivate: [AuthorizationGuardService]
			// }
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)]
})
export class CompanyRouting {}
